import { createQueryKeys } from '@lukemorales/query-key-factory';

export const notificationKeys = createQueryKeys('notifications', {
  recent: 'recentConnections',
  getAllNotifications: (onlyUnread: boolean, uid) => ({ onlyUnread, uid }),
  useQueryInterviewRequestNotificationByCalComBookingId: (
    calComBookingId: string,
  ) => ({ calComBookingId }),
});
